import BookmarkIcon from "@/helpers/svg/bookmarkIcon.svg";
import DevicesIcon from "@/helpers/svg/devicesIcons.svg";
import FinancialIcon from "@/helpers/svg/financialIcon.svg";
import HistoryIcon from "@/helpers/svg/historyIcon.svg";
import ProfileIcon from "@/helpers/svg/profileIcon.svg";
import SubscriptionIcon from "@/helpers/svg/subscriptionIcon.svg";
import {
  ageRangeFilters,
  contentTypeFilters,
  countryFilters,
  languageFilters,
  sortingFilters,
  yearFilters,
} from "./enums/filter.enum";

export const navItems = [
  {
    name: "Film",
    value: "فیلم",
    href: "/movie",
  },
  {
    name: "Serial",
    value: "سریال",
    href: "/series",
  },
  {
    name: "Programs",
    value: "برنامه",
    href: "/program",
  },
  {
    name: "Music",
    value: "موسیقی",
    href: "/music",
  },
  {
    name: "Anavatan",
    value: "آناوطن",
    href: "/anavatan",
  },
  {
    name: "Categories",
    value: "دسته‌بندی",
    href: "/category",
  },
];

import ChatSupportIcon from "@/helpers/svg/chatSupportIcon.svg";

export const profileMenu = [
  {
    name: "پروفایل",
    label: "account",
    id: "1",
    icon: <ProfileIcon />,
  },
  {
    name: "اشتراک",
    label: "subscription",
    id: "2",
    icon: <SubscriptionIcon />,
  },
  {
    name: "نشان شده ها",
    label: "favourites",
    id: "3",
    icon: <BookmarkIcon />,
  },
  {
    name: "تاریخچه تماشا",
    label: "history",
    id: "4",
    icon: <HistoryIcon />,
  },
  {
    name: "مالی",
    label: "transactions",
    id: "5",
    icon: <FinancialIcon />,
  },
  {
    name: "دستگاه های من",
    label: "devices",
    id: "6",
    icon: <DevicesIcon />,
  },
  {
    name: "پشتیبانی آنلاین",
    label: "chat",
    id: "7",
    icon: <ChatSupportIcon />,
  },
];

export const moviesList = [
  {
    name: "آرماسترانگ",
    image: "/movieList1.jpeg"
  },
  {
    name: "بتمن",
    image: "/movieList2.jpeg",
  },
  {
    name: "خانه کاغذی",
    image: "/movieList3.jpeg",
  },
  {
    name: "فیلم ۴",
    image: "/movieList4.jpeg",
  },
  {
    name: "فیلم ۵",
    image: "/movieList5.jpeg"
  },
  {
    name: "فیلم ۴",
    image: "/movieList7.jpeg",
  },
  {
    name: "فیلم ۵",
    image: "/movieList6.jpeg"
  },
  {
    name: "فیلم ۴",
    image: "/movieList8.jpeg",
  },
  {
    name: "فیلم ۵",
    image: "/movieList9.jpeg"
  },
  {
    name: "فیلم ۵",
    image: "/movieList10.jpeg"
  },
];

export const artistsList = [
  {
    name: "سیاوش مفیدی",
    role: "کارگردان",
    image: "/artists.png",
    id: "1",
  },
  {
    name: "سیاوش مفیدی",
    role: "کارگردان",
    image: "/artists.png",
    id: "2",
  },
  {
    name: "سیاوش مفیدی",
    role: "کارگردان",
    image: "/artists.png",
    id: "3",
  },
  {
    name: "سیاوش مفیدی",
    role: "کارگردان",
    image: "/artists.png",
    id: "4",
  },
  {
    name: "سیاوش مفیدی",
    role: "کارگردان",
    image: "/artists.png",
    id: "5",
  },
  {
    name: "سیاوش مفیدی",
    role: "کارگردان",
    image: "/artists.png",
    id: "6",
  },
  {
    name: "سیاوش مفیدی",
    role: "کارگردان",
    image: "/artists.png",
    id: "7",
  },
  {
    name: "سیاوش مفیدی",
    role: "کارگردان",
    image: "/artists.png",
    id: "8",
  },
  {
    name: "سیاوش مفیدی",
    role: "کارگردان",
    image: "/artists.png",
    id: "9",
  },
  {
    name: "سیاوش مفیدی",
    role: "کارگردان",
    image: "/artists.png",
    id: "10",
  },
  {
    name: "سیاوش مفیدی",
    role: "کارگردان",
    image: "/artists.png",
    id: "11",
  },
  {
    name: "سیاوش مفیدی",
    role: "کارگردان",
    image: "/artists.png",
    id: "12",
  },
  {
    name: "سیاوش مفیدی",
    role: "کارگردان",
    image: "/artists.png",
    id: "13",
  },
  {
    name: "سیاوش مفیدی",
    role: "کارگردان",
    image: "/artists.png",
    id: "14",
  },
  {
    name: "سیاوش مفیدی",
    role: "کارگردان",
    image: "/artists.png",
    id: "15",
  },
];

export const commentItems = [
  {
    name: "احمد عباسی",
    text: "عالی بود",
    id: 1,
  },
  {
    name: "۹۰۲۳***۰۹۱۲",
    text: "عالی بود",
    id: 2,
  },
  {
    name: "رضا عباسی",
    text: "عالی بود",
    id: 3,
  },
  {
    name: "رضا عباسی",
    text: "عالی بود",
    id: 4,
  },
  {
    name: "رضا عباسی",
    text: "عالی بود",
    id: 5,
  },
  {
    name: "رضا عباسی",
    text: "عالی بود",
    id: 6,
  },
];

export const searchFilters = [
  {
    label: "نوع محتوا",
    action: "type",
    items: contentTypeFilters,
    isStatic: true,
  },
  {
    label: "زبان فیلم",
    action: "language",
    items: languageFilters,
    isStatic: true,
  },
  {
    label: "کشور سازنده",
    action: "country",
    items: countryFilters,
    isStatic: true,
  },
  {
    label: "رده سنی",
    action: "ageRange",
    items: ageRangeFilters,
    isStatic: true,
  },
  {
    label: "دسته‌بندی",
    action: "category",
    items: [],
    isStatic: false,
  },
  {
    label: "ژانر",
    action: "genre",
    items: [],
    isStatic: false,
  },
  {
    label: "سال تولید",
    action: "year",
    items: yearFilters,
    isStatic: true,
  },
  {
    label: "ترتیب نمایش",
    action: "sort",
    items: sortingFilters,
    isStatic: true,
  },
];

export const bakhishMovie = [
  {
    name: "ارتش خاموش نبرد",
    id: 1,
    image: "./movie1.jpeg",
    rate: "7.2",
    popularity: "85%",
    genres: ["اکشن", "درام"],
  },
  {
    name: "ارتش خاموش نبرد",
    image: "./movie2.jpeg",
    id: 2,
    rate: "7.2",
    popularity: "85%",
    genres: ["اکشن", "درام"],
  },
  {
    name: "ارتش خاموش نبرد",
    image: "./movie3.jpeg",
    id: 3,
    rate: "7.2",
    popularity: "85%",
    genres: ["اکشن", "درام"],
  },
  {
    name: "ارتش خاموش نبرد",
    image: "./movie3.jpeg",
    id: 4,
    rate: "7.2",
    popularity: "85%",
    genres: ["اکشن", "درام"],
  },
];

export const bannerItems = [
  {
    name: "ارتش خاموش نبرد",
    id: 1,
    image: "/movieList4.jpeg",
  },
  {
    name: "ارتش خاموش نبرد",
    image: "/movieList4.jpeg",
    id: 2,
  },
  {
    name: "ارتش خاموش نبرد",
    image: "/movieList4.jpeg",
    id: 3,
  },
  {
    name: "ارتش خاموش نبرد",
    image: "/movieList4.jpeg",
    id: 4,
  },
  {
    name: "ارتش خاموش نبرد",
    image: "/movieList4.jpeg",
    id: 5,
  },
];
